import { render } from "./Audio.vue?vue&type=template&id=d6e9325c&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"

import "./Audio.vue?vue&type=style&index=0&id=d6e9325c&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e9325c"]])

export default __exports__